import * as Yup from 'yup';

export const FormSchema = Yup.object().shape({
  amount: Yup.number()
    .required('O campo Valor da cobrança é obrigatório')
    .min(0.01, 'O campo Valor da cobrança deve ser maior que zero')
    .nullable(true),
  description: Yup.string().required('O campo Descrição é obrigatório').nullable(true),
  due_date: Yup.date()
    .required('O campo Vencimento da cobrança é obrigatório')
    .nullable(true),
  payment_method_payment_gateway_id: Yup.string()
    .required('O campo Forma de pagamento é obrigatório')
    .nullable(true),
  company_payment_gateway_id: Yup.string()
    .required('O campo Provedor de pagamento é obrigatório')
    .nullable(true),
  charge_type: Yup.string().required('O tipo de cobrança é obrigatório').nullable(true),
  recurrence_cycle: Yup.string().when('charge_type', {
    is: 'RECURRING',
    then: Yup.string()
      .required('O campo Ciclo de recorrência é obrigatório')
      .nullable(true),
    otherwise: Yup.string().notRequired().nullable(true),
  }),
});
